import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { FormikErrors, useFormik } from 'formik'
import React from 'react'
import { UpdateControlField } from '../../types'
import { pinValidate } from '../../utils/businessUtil'

type Fields = Omit<UpdateControlField, 'houseId'>
type Props = {
	disabled: boolean
	initialValues: Fields
	handleSubmit: (fields: Fields) => void
}

// 電磁弁 (denji) の機器編集。デバイス設定（label + 制御ピン）のみ。
// 24時間ルールはシナリオ側 (DenjiManageTab / event) で設定する。
function EditDenjiControlForm(props: Props) {
	const {
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		setFieldTouched,
	} = useFormik<Fields>({
		initialValues: props.initialValues,
		validate: (values) => {
			const errors: FormikErrors<Fields> = {}

			if (!values.label) {
				errors.label = '必須です。'
			}
			if (pinValidate(values.activePin) || !values.activePin) {
				errors.activePin = '制御ピンを1から16の値で設定してください。'
			}

			return errors
		},
		onSubmit: (fields) => {
			props.handleSubmit(fields)
		},
	})

	const change = (name: keyof Fields, e: React.ChangeEvent<unknown>) => {
		e.persist()
		handleChange(e)
		setFieldTouched(name, true, false)
	}

	return (
		<div>
			<Typography>電磁弁を編集</Typography>
			<form style={{ display: 'grid', gap: '8px' }}>
				<TextField
					name="label"
					type="text"
					error={touched.label && Boolean(errors.label)}
					required
					disabled={props.disabled}
					label="名前"
					helperText={touched.label && errors.label}
					value={values.label}
					inputProps={{ 'data-test': 'denji-input-label' }}
					onChange={change.bind(null, 'label')}
					fullWidth
				/>
				<TextField
					name="activePin"
					type="number"
					error={touched.activePin && Boolean(errors.activePin)}
					required
					disabled={props.disabled}
					label="制御ピン(1~16)"
					helperText={touched.activePin && errors.activePin}
					value={values.activePin}
					inputProps={{ 'data-test': 'denji-input-activePin' }}
					onChange={change.bind(null, 'activePin')}
					fullWidth
				/>
				<Button
					variant="contained"
					color="primary"
					onClick={() => handleSubmit()}
					disabled={props.disabled}
					size={'large'}
				>
					更新する
				</Button>
			</form>
		</div>
	)
}

export default EditDenjiControlForm
